import CustomToast from "components/common/custom-toast";
import { alertTypes } from "constants/common";
import {
  APPROVAL_CONFIGURATION,
  EXPENSE_CATEGORY,
  EXPENSE_SUB_CATEGORY,
} from "constants/endpoints";
import { toast } from "react-toastify";
import { get, post, deleteApi, put, patch } from "services/network";

export const getExpenseCategories = async (obj) => {
  const params = {
    page: obj?.page ? obj.page : 1,
    perPage: obj?.perPage ? obj.perPage : 10,
    search: obj?.search ? obj.search : "",
    status: obj?.status ? obj.status : "",
  };

  try {
    const result = await get(
      `${EXPENSE_CATEGORY}?page=${params.page}&per=${params.perPage}&query=${params.search}&filter[status]=${params?.status}`,
      true,
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const createExpenseCategory = async (data, setErrors = () => {}) => {
  try {
    const result = await post(EXPENSE_CATEGORY, data, true);
    toast(
      <CustomToast
        variant={alertTypes.SUCCESS}
        message={"Expense Category Created Successfully"}
      />,
    );
    return result;
  } catch (error) {
    if (error?.response?.data) {
      setErrors(error?.response?.data.errors);
    }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={`Expense Category ${error?.response?.data?.errors[0]}`}
      />,
    );
    console.log(error);
  }
};

export const updateExpenseCategory = async (id, data, setErrors = () => {}) => {
  try {
    const result = await put(`${EXPENSE_CATEGORY}/${id}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.SUCCESS}
        message={"Expense Category Updated Successfully"}
      />,
    );
    return result;
  } catch (error) {
    // if (error?.response?.data) {
    //   setErrors(error?.response?.data.errors);
    // }
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={`Expense Category ${error?.response?.data?.errors[0]}`}
      />,
    );
    console.log(error);
  }
};

export const deleteExpenseCategory = async (id) => {
  try {
    const result = await deleteApi(`${EXPENSE_CATEGORY}/${id}`, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message={"Expense Category Deleted Successfully"}
      />,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "Error"}
      />,
    );
    console.log(error);
  }
};

// Sub Category APIs
export const getExpenseSubCategories = async (obj) => {
  const params = {
    page: obj?.page ? obj.page : 1,
    perPage: obj?.perPage ? obj.perPage : 10,
    search: obj?.search ? obj.search : "",
    expense_request_id: obj.expense_request_id ? obj.expense_request_id : "",
    status: obj?.status ? obj.status : "",
  };

  try {
    const result = await get(
      `${EXPENSE_SUB_CATEGORY}?page=${params.page}&per=${params.perPage}&filter[status]=${params.status}&filter[expense_category_id]=${params?.expense_request_id}&query=${params.search}`,
      true,
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const createExpenseSubCategory = async (data) => {
  try {
    const result = await post(EXPENSE_SUB_CATEGORY, data, true);
    toast(
      <CustomToast
        variant={alertTypes.SUCCESS}
        message={"Expense Sub Category Created Successfully"}
      />,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={`Expense Sub Category ${error?.response?.data?.errors[0]}`}
      />,
    );
    console.log(error);
  }
};

export const updateExpenseSubCategory = async (data, id) => {
  try {
    const result = await put(`${EXPENSE_SUB_CATEGORY}/${id}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.SUCCESS}
        message={"Expense Sub Category Updated Successfully"}
      />,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={`Expense Sub Category ${error?.response?.data?.errors[0]}`}
      />,
    );
    console.log(error);
  }
};

export const deleteExpenseSubCategory = async (id) => {
  try {
    const result = await deleteApi(`${EXPENSE_SUB_CATEGORY}/${id}`, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message={"Expense Sub Category Deleted Successfully"}
      />,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "Error"}
      />,
    );
    console.log(error);
  }
};
export const getApprovalConfigurations = async (obj) => {
  const params = {
    page: obj?.page ? obj.page : 1,
    perPage: obj?.perPage ? obj.perPage : 10,
    search: obj?.search ? obj.search : "",
    status: obj?.status ? obj.status : "",
  };

  try {
    const result = await get(
      `${APPROVAL_CONFIGURATION}?page=${params.page}&per=${params.perPage}&query=${params.search}&status=${params?.status}`,
      true,
    );
    return result;
  } catch (error) {
    console.log(error);
  }
};

export const createApprovalConfiguration = async (data) => {
  try {
    const result = await post(APPROVAL_CONFIGURATION, data, true);
    toast(
      <CustomToast
        variant={alertTypes.SUCCESS}
        message={"Approval Configuration Created Successfully"}
      />,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={`Payment Method  ${error?.response?.data?.errors?.approval_method}`}
      />,
    );
    console.log(error);
  }
};

export const updateApprovalConfiguration = async (data, id) => {
  try {
    const result = await put(`${APPROVAL_CONFIGURATION}/${id}`, data, true);
    toast(
      <CustomToast
        variant={alertTypes.SUCCESS}
        message={"Approval Configuration Updated Successfully"}
      />,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={`Payment Method  ${error?.response?.data?.errors?.approval_method}`}
      />,
    );
    console.log(error);
  }
};

export const deleteApprovalConfiguration = async (id) => {
  try {
    const result = await deleteApi(`${APPROVAL_CONFIGURATION}/${id}`, true);
    toast(
      <CustomToast
        variant={alertTypes.INFO}
        message={"Approval Configuration Deleted Successfully"}
      />,
    );
    return result;
  } catch (error) {
    toast(
      <CustomToast
        variant={alertTypes.DANGER}
        message={error?.response?.statusText || "Error"}
      />,
    );
    console.log(error);
  }
};
